import { render, staticRenderFns } from "./PettyCashCertificateListBox.vue?vue&type=template&id=20bbd5a4"
import script from "./PettyCashCertificateListBox.vue?vue&type=script&lang=js"
export * from "./PettyCashCertificateListBox.vue?vue&type=script&lang=js"
import style0 from "../../../assets/css/Table.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PettyCashCertificateListBox.vue?vue&type=style&index=1&id=20bbd5a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports